<template>
    <l-layer-group
        :layer-type="overlay.type"
        v-model:visible="overlay_visible"
        :name="(overlay.name)"
        ref="notificationsLayer"
        @ready="onReady()"
    >
        <l-feature-group
            ref="notificationsCluster"
            id="notifications-cluster"
        ></l-feature-group>
    </l-layer-group>
</template>

<script>
import {LFeatureGroup, LLayerGroup} from "@vue-leaflet/vue-leaflet";
import {mapGetters} from "vuex";

export default {
    name: "sectionMap_layer_notificatons",
    emits: ['update:modelValue'],
    inject: ['L', 'createMarker', 'mapLeafletObject'],
    props: {
        modelValue: Object,
    },
    components: {
        LLayerGroup,
        LFeatureGroup,
    },
    data() {
        return {
            notificationsLayer: null,
            notificationsCluster: null,
            notificationEventMarker: null,
        }
    },
    computed: {
        ...mapGetters([
            "getEventShowOnMap",
        ]),
        overlay() {
            return this.modelValue
        },
        overlay_visible: {
            get() {
                return this.overlay?.visible
            },
            set(vl) {
                this.$emit('update:modelValue', {...this.overlay, visible: vl})
            },
        },
        isShowLayer() {
            return this.overlay?.showLayer
        },
        eventOnMap() {
            if(!this.isShowLayer) return null
            let e = this.getEventShowOnMap || {}
            return ([e.type,e.xid]).join('/')
        },
    },
    watch: {
        eventOnMap: {
            handler: function (newEvent, oldEvent) {
                if (oldEvent || newEvent) {
                    // if(this.$isDevelopment) console.log('showNotificationEvent', newEvent, oldEvent)
                }
                //this.debouncedShowNotificationEvent();
                this.showNotificationEvent()
            },
            // deep: true
        },
    },
    methods: {
        async showNotificationEvent() {
            let event = this.getEventShowOnMap
            //this.notificationsCluster.clearLayers()//???
            //ToDo fix removeLayer
            if (this.notificationEventMarker) {
                // this.notificationEventMarker.closePopup()
                if(this.notificationsCluster.hasLayer(this.notificationEventMarker)) {
                    this.notificationsCluster.removeLayer(this.notificationEventMarker)
                }
                this.notificationEventMarker = null
            }
            if (!event?.latlng) {
                return;
            }

            let icon = event?.image;
            try {
                icon = require('@/assets/img/events/map__pin-'+icon+'.png') ? icon : 'other';
            } catch (e) {
                icon = 'other';
            }
            let options = {
                icon: {
                    //???
                    assetPath: '/img/events/map__pin-' + icon + '.png',
                    className: ' event-marker '+(event.type || 'custom')+'-marker',
                    anchorK: [0.5, 1]
                },
                popup: {
                    anchorK: [0, -1]
                },
            }
            this.notificationEventMarker = await this.createMarker(event.latlng, options)
            if (this.notificationEventMarker) {
                this.notificationEventMarker.bindPopup(event.message || event.text)
                this.notificationsCluster.addLayer(this.notificationEventMarker)
                this.notificationEventMarker.openPopup()
            }
        },
        onReady() {
            this.notificationsLayer = this.$refs.notificationsLayer.leafletObject
            this.notificationsCluster = this.$refs.notificationsCluster.leafletObject
        }
    },
    updated() {
        if(this.$isDevelopment) console.log('updated', this._.type.name)
    }
}
</script>

<style scoped>

</style>